import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  { num: 1, title: 'Discovery Call', subtitle: '30 minutes', desc: 'We learn your call types, escalation rules, CRM setup, and knowledge base.' },
  { num: 2, title: 'We Build Your Agent', subtitle: '48–72 hours', desc: 'Custom AI voice agent, helpdesk integration, routing logic, and ticket templates.' },
  { num: 3, title: 'Pilot Goes Live', subtitle: 'Day 3–4', desc: 'Real calls routed to your AI. You monitor every interaction via recordings and transcripts.' },
  { num: 4, title: 'You Review & Approve', subtitle: 'Day 14', desc: 'After 14 days, you decide. No payment until you\'re confident it\'s working.' },
  { num: 5, title: 'We Optimize Weekly', subtitle: 'Ongoing', desc: 'Script improvements, routing logic updates, knowledge base expansion — every week.' },
];

const HowItWorks = () => (
  <section className="py-12 md:py-16 bg-slate-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        className="text-center mb-10 md:mb-12"
      >
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">How It Works</h2>
        <p className="text-lg text-slate-600 max-w-2xl mx-auto">We handle the entire setup. You just handle the calls that actually need a human.</p>
      </motion.div>

      <div className="relative">
        <div className="hidden lg:block absolute top-10 left-0 w-full h-0.5 bg-slate-200 -z-10"></div>
        <div className="grid lg:grid-cols-5 gap-6">
          {steps.map((step, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ delay: i * 0.15 }}
              className="relative bg-white lg:bg-transparent p-6 lg:p-0 rounded-2xl shadow-sm lg:shadow-none border lg:border-none border-slate-100"
            >
              <div className="w-20 h-20 mx-auto bg-white rounded-full border-4 border-slate-50 flex items-center justify-center mb-4 shadow-sm z-10 relative">
                <div className="w-14 h-14 bg-green-700 rounded-full flex items-center justify-center text-white">
                  <span className="font-bold text-lg">{step.num}</span>
                </div>
              </div>
              <div className="text-center">
                <h3 className="font-bold text-slate-900 mb-1">{step.title}</h3>
                <div className="text-xs font-bold text-green-700 uppercase tracking-wide mb-2">{step.subtitle}</div>
                <p className="text-sm text-slate-600 leading-relaxed">{step.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default HowItWorks;